import { createRouter, createWebHistory } from 'vue-router'
import Upload from '../views/Upload.vue'
import ViewReport from '../views/ViewReport.vue'
import PdfViewer from '../views/PdfViewer.vue'
import ReportList from '../views/ReportList.vue'
import Login from '../views/Login.vue'
import { hasPermission } from '../utils/auth.js'

// Website Components
import WebsiteLayout from '../views/website/Layout.vue'
import Home from '../views/website/Home.vue'
import About from '../views/website/About.vue'
import News from '../views/website/News.vue'
import NewsDetail from '../views/website/NewsDetail.vue'
import Services from '../views/website/Services.vue'
import Verification from '../views/website/Verification.vue'

const routes = [
  // 官网路由
  {
    path: '/',
    component: WebsiteLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
        meta: { title: '首页 - 国测检测' }
      },
      {
        path: 'about',
        name: 'About',
        component: About,
        meta: { title: '关于我们 - 国测检测' }
      },
      {
        path: 'news',
        name: 'News',
        component: News,
        meta: { title: '新闻资讯 - 国测检测' }
      },
      {
        path: 'news/:slug',
        name: 'NewsDetail',
        component: NewsDetail,
        props: true,
        meta: { title: '新闻详情 - 国测检测' }
      },
      {
        path: 'services',
        name: 'Services',
        component: Services,
        meta: { title: '我们的服务 - 国测检测' }
      },
      {
        path: 'verification',
        name: 'Verification',
        component: Verification,
        meta: { title: '报告查真伪 - 国测检测' }
      },
      {
        path: 'verification/detail',
        name: 'VerificationDetail',
        component: Verification,
        meta: { title: '报告详情 - 国测检测' }
      }
    ]
  },
  
  // 系统路由
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { 
      requiresAuth: false,
      title: '登录'
    }
  },
  {
    path: '/ReportList',
    name: 'ReportList',
    component: ReportList,
    meta: { 
      requiresAuth: true,
      title: '报告列表'
    }
  },
  {
    path: '/upload',
    name: 'Upload',
    component: Upload,
    meta: { 
      requiresAuth: false,
      title: '上传报告'
    }
  },
  {
    path: '/edit/:id',
    name: 'EditReport',
    component: Upload,
    props: true,
    meta: { 
      requiresAuth: false,
      title: '编辑报告'
    }
  },
  {
    path: '/view/:id',
    name: 'ViewReport',
    component: ViewReport,
    props: true,
    meta: { 
      requiresAuth: false,
      title: '查看报告'
    }
  },
  {
    path: '/pdf-viewer/:id',
    name: 'PdfViewer',
    component: PdfViewer,
    props: true,
    meta: { 
      requiresAuth: false,
      title: '文档预览'
    }
  },
  {
    path: '/reports',
    redirect: '/ReportList'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { top: 0 }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    if(to.name === 'ViewReport'){
      document.title = '查看报告 — 检验报告管理系统'
    }
    else if(to.name === 'ReportList'){
      document.title = '报告列表 — 检验报告管理系统'
    }
    else if(to.name === 'Login'){
      document.title = '登录 — 检验报告管理系统'
    }
    else{
      document.title = to.meta.title
    }
  }
  
  // 检查路由是否需要认证
  if (to.meta.requiresAuth) {
    if (hasPermission()) {
      next()
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    // 不需要认证的路由
    if (to.path === '/login' && hasPermission()) {
      next({ path: '/ReportList' })
    } else {
      next()
    }
  }
})

export default router
